import { Alert, AlertTitle, Snackbar, IconButton, Stack, Button, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { useNotificationStore } from '@/stores/notificationStore';
import { useIsMobile } from '@/hooks/useIsMobile';

export function NotificationProvider() {
  const { notifications, removeNotification } = useNotificationStore();
  const { t } = useTranslation('common');
  const isMobile = useIsMobile();

  return (
    <Stack
      spacing={1}
      sx={{
        position: 'fixed',
        // On mobile: above bottom nav (64px) + safe area + FAB clearance
        bottom: isMobile ? 'calc(80px + env(safe-area-inset-bottom, 0px))' : 24,
        right: isMobile ? 16 : 24,
        left: isMobile ? 16 : 'auto',
        zIndex: (theme) => theme.zIndex.snackbar,
      }}
      role="region"
      aria-label={t('notifications')}
    >
      {notifications.map((notification) => (
        <Snackbar
          key={notification.id}
          open={true}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          sx={{ position: 'relative', bottom: 'auto', right: 'auto' }}
        >
          <Alert
            severity={notification.type}
            variant="filled"
            role={notification.type === 'error' ? 'alert' : 'status'}
            aria-live={notification.type === 'error' ? 'assertive' : 'polite'}
            aria-atomic="true"
            onClick={() => removeNotification(notification.id)}
            action={
              <>
                {notification.action && (
                  <Button
                    size="small"
                    color="inherit"
                    variant="outlined"
                    onClick={(e) => {
                      e.stopPropagation();
                      notification.action?.onClick();
                      removeNotification(notification.id);
                    }}
                  >
                    {notification.action.label}
                  </Button>
                )}
                <Tooltip title={t('close')}>
                  <IconButton
                    size="small"
                    color="inherit"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeNotification(notification.id);
                    }}
                    aria-label={t('close')}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </>
            }
            sx={{
              minWidth: isMobile ? 'auto' : 300,
              maxWidth: 400,
              width: '100%',
              cursor: 'pointer',
            }}
          >
            <AlertTitle>{notification.title}</AlertTitle>
            {notification.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  );
}
